import React from "react";
import { Switch, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { PrivateRoute, Layout } from "./components";
import './styles.scss';
import { publicRoutes, privateRoutes } from "./routes";
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.min.css";


const App = () => (
  <AuthProvider>
    <div>
      <Switch>
        <Layout>
          {publicRoutes.map(route => (
            <Route exact path={route.path} component={route.Component} key={route.id} />
          ))}
          {/* {privateRoutes.map(route => (
            <PrivateRoute exact path={route.path} component={route.Component} key={route.id} />
          ))} */}
        </Layout>
      </Switch>
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

    </div>
  </AuthProvider>
);

export default App;